import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const residenceTypeMap: Record<ResidenceType, MapItem> = {
  primary_residence: { label: 'Primary residence' },
  investment_property: { label: 'Investment property' },
  second_home: { label: 'Second home' },
  commercial_property: { label: 'Commercial property' },
  other: { label: 'Other' },
}

export const residenceTypeSchema = z.enum(Object.keys(residenceTypeMap) as [ResidenceType, ...ResidenceType[]])

export type ResidenceType =
  | 'primary_residence'
  | 'investment_property'
  | 'second_home'
  | 'commercial_property'
  | 'other'
